import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
const sizeMap = {
    inherit: {
        fontSize: '86%',
    },
    large: {
        fontSize: tokens.fontSizes.medium,
    },
    medium: {
        fontSize: tokens.fontSizes.small,
    },
    small: {
        fontSize: tokens.fontSizes.xsmall,
    },
    xlarge: {
        fontSize: tokens.fontSizes.large,
    },
};
const codeStaticStyle = css({
    borderRadius: tokens.borderRadius.medium,
    fontFamily: tokens.fontFamilies.mono,
    fontWeight: tokens.fontWeights.regular,
    margin: '0 2px',
    padding: `2px ${tokens.spacingNew.tiny}`,
    whiteSpace: 'nowrap',
});
export function codeStyle({ inverted, size }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        codeStaticStyle,
        css({
            backgroundColor: theme.background.transparent,
            color: theme.text.main,
            fontSize: sizeMap[size].fontSize,
            lineHeight: size === 'inherit' ? 'inherit' : tokens.lineHeights.relaxed,
        }),
    ];
}
